import * as React from "react";
import { MenuContainer, MenuList } from "./Menu.styled";
import { MenuItem } from "./MenuItem";
import { observer } from "mobx-react";
import { useStores } from "../../../../../stores";
import { useTranslation } from "react-i18next";
import { InstrumentUnion } from "../../../../../types/instrument.type";
import { MenuUnion } from "../../../../../types";

interface MenuProps {}

export const Menu = observer(({}: MenuProps) => {
	const { t } = useTranslation();

	const { menuStore, authStore } = useStores();

	return (
		<MenuContainer>
			<MenuList>
				{menuStore.list.map((menu) => {
					if (authStore.isAuth && menu.isAuth) {
						return null;
					}

					// Модернизируем в зависимости от языка
					menu = {
						...menu,
						...{
							name: t(`header.${menu.name.toLowerCase() as MenuUnion}`),
						},
					};

					if (authStore.isAuth && menu.link === "/pricing") {
						return null;
					}

					return <MenuItem key={menu.link} {...menu} />;
				})}
			</MenuList>
		</MenuContainer>
	);
});
